/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetEmailHistoryOptions, AdminGetEmailHistoryStatus200, AdminGetEmailHistoryStatus422 } from '../models/AdminGetEmailHistory'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetEmailHistory } from '../clients/axios/adminGetEmailHistory'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetEmailHistoryQueryKey = ({ query }: Omit<AdminGetEmailHistoryOptions, 'headers'> = {}) => [{ url: '/admin/org/email-history' }, ...(query ? [query] : [])] as const

type AdminGetEmailHistoryQueryKey = ReturnType<typeof adminGetEmailHistoryQueryKey>

export function adminGetEmailHistoryQueryOptions({ query }: AdminGetEmailHistoryOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetEmailHistoryQueryKey({ query })
  return queryOptions<AdminGetEmailHistoryStatus200, ResponseErrorConfig<AdminGetEmailHistoryStatus422>, AdminGetEmailHistoryStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetEmailHistory({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @description Get paginated email send records.
 * @summary Get Email Sends
 * {@link /admin/org/email-history}
 */
export function useAdminGetEmailHistory<TData = AdminGetEmailHistoryStatus200, TQueryData = AdminGetEmailHistoryStatus200, TQueryKey extends QueryKey = AdminGetEmailHistoryQueryKey>({ query }: { query?: AdminGetEmailHistoryOptions['query'] | (() => AdminGetEmailHistoryOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<AdminGetEmailHistoryStatus200, ResponseErrorConfig<AdminGetEmailHistoryStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetEmailHistoryQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetEmailHistoryQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetEmailHistoryStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
